// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"280":"aa362974","467":"6641c822","564":"1ddda6ea","655":"68eb0051","956":"de1f0e67"}[chunkId] + ".chunk.css";
};